import React, { PropsWithChildren, useCallback } from 'react';
import {
  Detection,
  DetectionCleaningStatus,
} from '../../../types/prediction.type';
import {
  useSetDetectionStatus,
  useSetNextDetectionId,
} from '../../../contexts/predictions.hooks';

export function StatusInput({
  detection,
  status,
  children,
}: PropsWithChildren<{
  detection: Detection;
  status: DetectionCleaningStatus;
}>) {
  const setDetectionStatus = useSetDetectionStatus();
  const setNextDetection = useSetNextDetectionId();

  const onChange = useCallback(() => {
    setDetectionStatus({
      status,
      detectionId: detection.annotationId,
    });
    setNextDetection();
  }, [detection.annotationId, status]);

  return (
    <label className="radio-inline" title={status}>
      <input
        type="radio"
        name={`${detection.type}-${detection.confidence}-status`}
        value={status}
        checked={detection.status === status}
        onChange={onChange}
      />
      {children}
    </label>
  );
}
